import React, { useEffect, useContext } from "react";
import { Form, Divider, Input } from "antd";

import PresentIllness from "./PresentIllness/PresentIllness";

import "./HistoryForm.css";
import PastMedicalHistory from "./PastMedicalHistory/PastMedicalHistory";
import KnownAllergies from "./KnownAllergies/KnownAllergies";
import { DailyReviewContext } from "../../Doctor/DailyReview/DailyReviewFormProvider";

const DrHistoryFormDR = ({ form = {} }) => {
  const { formData } = useContext(DailyReviewContext);
  useEffect(() => {
    form.setFieldsValue(formData?.history);
  }, [formData]);
  return (
    <>
      <PresentIllness context={DailyReviewContext} form={form} />
      <Divider />
      <PastMedicalHistory context={DailyReviewContext} form={form} />
      <Divider />
      <KnownAllergies context={DailyReviewContext} form={form} />
      <Divider />
      <Form.Item name="present_complaints">
        <Input placeholder="Enter Present Complaints" />
      </Form.Item>
    </>
  );
};

export default DrHistoryFormDR;
